import { render, staticRenderFns } from "./Contact-form.vue?vue&type=template&id=5bf6546c"
import script from "./Contact-form.vue?vue&type=script&lang=js"
export * from "./Contact-form.vue?vue&type=script&lang=js"
import style0 from "./Contact-form.vue?vue&type=style&index=0&id=5bf6546c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports